<template>
    <div class="text-functional-information flex flex-row items-center gap-1 text-sm">
        <SvgComponent icon="info" class="shrink-0" />
        <span class="text-functional-information">
            {{ message }}
        </span>
    </div>
</template>

<script lang="ts" setup>
interface InlineMessageProps {
    message: string;
}

const { message } = defineProps<InlineMessageProps>();
</script>
